<template>
  <div style="display: inline-block;">
    <!-- 학부선택 START -->
    <!-- HIDDEN FOR ysPress! -->
    <div class="select_area select_college">
      <div
        v-on-clickaway="closeParent"
        class="select_item"
        :class="{ active: showParent }"
      >
        <button type="button" class="select_option" @click="toggleParent">
          <span class="txt">{{ category.parent.catgryNm || '학부 선택' }}</span
          ><span class="arrow blind">열기</span>
        </button>

        <ul class="select_list">
          <li class="tit">
            {{ $t('library.bookcategoryrow.7806')
            }}<button class="select_list_close an_a" @click="toggleParent">
              <span class="svg_close"></span
              ><span class="an_t">{{ $t('library.deletemodal.close') }}</span>
            </button>
          </li>
          <!-- CATEGORY LIST ITEMS -->
          <li
            v-for="(parent, parentIdx) in getMainAllCategories"
            :key="parentIdx"
          >
            <button
              type="button"
              class="list_option"
              @click="chooseParent(parent)"
            >
              <span>{{ parent.catgryNm }}</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <!-- 학부선택 END -->

    <span class="svg_next">></span>

    <!-- Select SubCategory 1 START -->
    <div class="select_area select_college">
      <div
        v-on-clickaway="closeChild"
        class="select_item"
        :class="{ active: showChild }"
      >
        <button type="button" class="select_option" @click="toggleChild">
          <span class="txt">{{ category.child.catgryNm || '카테고리' }}</span
          ><span class="arrow blind">열기</span>
        </button>

        <ul class="select_list">
          <li class="tit">
            {{ $t('library.bookcategoryrow.4316')
            }}<button class="select_list_close an_a" @click="toggleChild">
              <span class="svg_close"></span
              ><span class="an_t">{{ $t('library.deletemodal.close') }}</span>
            </button>
          </li>
          <template v-if="!isSelfBookLoading">
            <li v-for="(c, childIdx) in child" :key="childIdx">
              <button type="button" class="list_option" @click="chooseChild(c)">
                <span>{{ c.catgryNm }}</span>
              </button>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <!-- Select SubCategory 1 END -->

    <span v-if="children && children.length > 0" class="svg_next">></span>

    <!-- Select SubCategory 2 START -->
    <div
      v-if="children && children.length > 0"
      class="select_area select_college"
    >
      <div
        v-on-clickaway="closeChildren"
        class="select_item"
        :class="{ active: showChildren }"
      >
        <button type="button" class="select_option" @click="toggleChildren">
          <span class="txt">{{ category.children.catgryNm || '카테고리' }}</span
          ><span class="arrow blind">열기</span>
        </button>

        <ul class="select_list">
          <li class="tit">
            {{ $t('library.bookcategoryrow.785')
            }}<button class="select_list_close an_a" @click="toggleChildren">
              <span class="svg_close"></span
              ><span class="an_t">{{ $t('library.deletemodal.close') }}</span>
            </button>
          </li>
          <template v-if="!isSelfBookLoading">
            <li v-for="(cr, childrenIdx) in children" :key="childrenIdx">
              <button
                type="button"
                class="list_option"
                @click="chooseChildren(cr)"
              >
                <span>{{ cr.catgryNm }}</span>
              </button>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <!-- Select SubCateogry 2 END -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showParent: false,
      showChild: false,
      showChildren: false,
      parents: [],
      child: [],
      children: []
    }
  },
  computed: {
    ...mapGetters(['isSelfBookLoading', 'getMainAllCategories'])
  },
  mounted() {
    //If editing categories
    if (this.category.parent.catgryNm) {
      const child = this.getMainAllCategories.find(
        (cat) => cat.catgryCd === this.category.parent.catgryCd
      )
      if (child) {
        this.child = child.subList

        if (this.category.child.catgryNm) {
          const children = this.child.find(
            (cat) => cat.catgryCd === this.category.child.catgryCd
          )

          this.children = children ? children.subList : []
        }
      }
    }
  },
  methods: {
    // Parent Category
    toggleParent() {
      this.showParent = !this.showParent
    },
    closeParent() {
      this.showParent = false
    },
    async chooseParent(category) {
      this.showParent = false
      this.category.parent = category
      this.child = category.subList || []
    },
    // Sub Category 1
    toggleChild() {
      this.showChild = !this.showChild
    },
    closeChild() {
      this.showChild = false
    },
    chooseChild(child) {
      this.showChild = false
      this.category.child = child
      this.children = child.subList || []

      if (!this.children.length) {
        this.category.children = {}
      }
    },
    // Sub Category 2
    toggleChildren() {
      this.showChildren = !this.showChildren
    },
    closeChildren() {
      this.showChildren = false
    },
    chooseChildren(children) {
      this.showChildren = false
      this.category.children = children
    }
  }
}
</script>
<style lang="scss" scoped>
.select_item.active .select_list {
  max-height: 300px;
  overflow-y: scroll;
}
</style>
